import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import 'unfonts.css';
import { initDevTools } from './utils/devUtils.ts';
import { initTracker } from './utils/track.ts';
import { initSentry } from './utils/sentryUtils.ts';
import initMobileEvents from './utils/mobileEvents.ts';

initDevTools();
initTracker();
initSentry();
initMobileEvents();

const rootElement = document.getElementById('root');

ReactDOM.createRoot(rootElement!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
